var map = {
	"./sticker_jelly_balloon_orange.png": 469,
	"./sticker_jelly_bear_brown.png": 379,
	"./sticker_jelly_bow_pink.png": 5179,
	"./sticker_jelly_cat_pink.png": 2458,
	"./sticker_jelly_chick_yellow.png": 7233,
	"./sticker_jelly_cloud_blue.png": 1254,
	"./sticker_jelly_clover_green.png": 5022,
	"./sticker_jelly_crown_yellow.png": 7920,
	"./sticker_jelly_diamond_blue.png": 2017,
	"./sticker_jelly_dog_blue.png": 4482,
	"./sticker_jelly_flower_purple.png": 6433,
	"./sticker_jelly_frog_green.png": 3461,
	"./sticker_jelly_heart_pink.png": 6520,
	"./sticker_jelly_heart_red.png": 3580,
	"./sticker_jelly_panda_white.png": 5101,
	"./sticker_jelly_planet_blue_ring.png": 4475,
	"./sticker_jelly_rabbit_white.png": 4342,
	"./sticker_jelly_speech_bubble_purple.png": 5291,
	"./sticker_jelly_star_yellow.png": 9652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6982;